import React from 'react';

const PageTabs = ({ activeTab, setActiveTab, tabs }) => {
  const tabStyle = (isActive) => ({
    padding: '8px 16px',
    border: 'none',
    borderBottom: isActive ? '4px solid #1976d2' : '4px solid transparent',
    background: isActive ? '#def' : 'none',
    color: isActive ? '#1976d2' : '#333',
    fontWeight: isActive ? 700 : 500,
    
    fontSize: 14,
    cursor: 'pointer',
    outline: 'none',
    transition: 'color 0.2s, border-bottom 0.2s'
  });

  return (
    <div style={{ display: 'flex', gap: 0}}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          style={tabStyle(activeTab === tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default PageTabs;
